import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { setModalFilterDay } from "../../../store/actions/modalActions";
import moment from "moment-timezone";
import "react-bootstrap-typeahead/css/Typeahead.css";
import styles from "./ListSessionsCardSelect.module.scss";
import { FilterDropdown } from "./FilterDropdown";
import SessionList from "./SessionList";

export const ListSessionsCardSelect = ({ cards, setCards }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [seminarCards, setSeminarCards] = useState([]);
  const [seminarDays, setSeminarDays] = useState([]);
  const [currentSessionDay, setCurrentSessionDay] = useState("All");
  const [seminarCardsBack, setSeminarCardsBack] = useState();
  const localSessionFilterDay = localStorage.getItem("sessionFilterDay");

  const openCurrentSession = (item) => {
    if (item?.event?.related && Array.isArray(item.event.related))
      item.event.related = item.event.related?.map((r) => ({
        label: r.title,
        value: r._id,
      }));
    history.push({
      pathname: "/sessions",
      state: { item },
    });
  };

  const groupSessionsByDay = (cards) => {
    if (cards && Array.isArray(cards)) {
      const sessions = [...cards];
      sessions.sort((a, b) => (a.startDate > b.startDate ? 1 : -1));
      const daysArr = new Set();
      const groupedSessions = sessions.reduce((acc, session) => {
        if (!session.startDate) {
          return acc;
        }

        // Handle both ISO and MM/DD/YYYY formats
        let date;
        if (session.startDate.includes('/')) {
          const [month, day, year] = session.startDate.split('/');
          date = moment(`${year}-${month}-${day}`).format("MM/DD/YYYY");
        } else {
          date = moment(session.startDate).format("MM/DD/YYYY");
        }

        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(session);
        if (session.sessionStatus !== "Hidden") {
          daysArr.add(date);
        }

        return acc;
      }, {});

      return Array.from(daysArr);
    }
    return [];
  };

  const getSessionsByDay = (e) => {
    const selectedDay = e.target.value;
    if (selectedDay === "All") {
      localStorage.removeItem("sessionFilterDay");
      setCurrentSessionDay("All");
      setSeminarCards(seminarCardsBack);
    } else {
      if (seminarCardsBack && Array.isArray(seminarCardsBack)) {
        const sessions = seminarCardsBack.filter((session) => {
          if (!session.startDate) return false;

          // Handle both ISO and MM/DD/YYYY formats
          let sessionDate;
          if (session.startDate.includes('/')) {
            sessionDate = session.startDate;
          } else {
            sessionDate = moment(session.startDate).format("MM/DD/YYYY");
          }

          return sessionDate === selectedDay;
        });

        // Sort sessions by time within the day
        sessions.forEach((session) => {
          let isoDate;
          if (session.startDate.includes('/')) {
            const [month, day, year] = session.startDate.split('/');
            isoDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
          } else {
            isoDate = moment(session.startDate).format("YYYY-MM-DD");
          }

          const time = moment(session.startTime, "hh:mm A").format("HH:mm:ss");
          const dayTime = moment(`${isoDate} ${time}`, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");
          session.dayTime = new Date(dayTime);
        });

        sessions.sort((a, b) => (a.dayTime > b.dayTime ? 1 : -1));

        setCurrentSessionDay(selectedDay);
        dispatch(setModalFilterDay(selectedDay));
        localStorage.setItem("sessionFilterDay", selectedDay);
        setSeminarCards(sessions);
      }
    }
  };

  useEffect(() => {
    setCurrentSessionDay("All");

    if (cards && Array.isArray(cards)) {
      cards.forEach((session) => {
        if (session?.startDate) {
          const date = moment.utc(session.startDate).format("MM/DD/YYYY");
          session.startDate = date;
        }
      });
      setSeminarDays(groupSessionsByDay(cards));
      setSeminarCards(cards);
      setSeminarCardsBack(cards);
    }
  }, [cards]);

  const updateSession = (updatedSessions) => {
    const _cards = seminarCards.map((session) => {
      const updatedSession = updatedSessions.find((s) => s._id === session._id);
      return {
        ...session,
        displayOrder: updatedSession?.displayOrder,
      };
    });
    setCards(_cards);
  }

  console.log("seminarDays", seminarDays);
  return (
    <>
      {seminarDays.length && (
        <FilterDropdown
          options={seminarDays}
          currentSelection={currentSessionDay}
          onChange={getSessionsByDay}
        />
      )}
      <div className={styles.total}>Total:
        <span className={styles.totalNumber}>
          {seminarCards.length || 0} sessions
        </span>
      </div>
      {seminarDays.length && (
        <SessionList
          seminarCards={seminarCards}
          openCurrentSession={openCurrentSession}
          onOrderUpdate={updateSession}
        />
      )}
    </>
  );
};
